import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomUrlSerializer } from "../../shared/models/UrlSerializer/custom-url-serializer";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auth-sidebar',
  templateUrl: './auth-sidebar.component.html',
  styleUrls: ['./auth-sidebar.component.scss']
})
export class AuthSidebarComponent implements OnInit, OnDestroy {
  url: any = '';
  unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private router: Router) {
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.url = CustomUrlSerializer.decript(val.url).replace('/', '') || 'subscribe';
      }
    });
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  goToLandingPage() {
    window.open(environment.landingPageUrl, '_self');
  }
}
